(function () {
	'use strict';

	angular
		.module('mx.components')

		/**
		 * @ngdoc directive
		 * @name mx.components:mxDraggable
		 * @module mx.components
		 * @restrict A
		 *
		 * @description
		 * Enables possibility to drag element.
		 *
		 * `mxDraggable` gets string.
		 *    If it's `false` then element-dragging will disabled.
		 *    If it's JSON - it will be passed to droppable element.
		 *
		 * Example 1:
		 * ```html
		 *    <div mx-draggable='{"mydata": 123}'></div>
		 *    <div mx-droppable="vm.onDrop($event)"></div>
		 * ```
		 *
		 * Example 2:
		 * ```html
		 *    <div mx-draggable='{{ vm.draggable ? "{\"mydata\" 123}" : "false" }}'></div>
		 *    <div mx-droppable="{{ vm.draggable ? "vm.onDrop($event)" : "false" }}'></div>
		 * ```
		 *
		 **/
		.directive('mxDraggable', [
			'mx.components.DragNDropUtils',
			function mxDraggableDirective(dragNDropUtils) {
				return {
					restrict: 'A',
					link: function (scope, element, attrs) {
						var dragstartHandler = function (event) {
							var dropAttrVal, data;
							if (event && event.target) {
								dropAttrVal = $(event.target).closest('[mx-draggable]').attr('mx-draggable');
								data = JSON.parse(dropAttrVal);
								if (data) {
									dragNDropUtils.setDropData(event, data);
								}
							}
						};

						var handleDragging = function () {
							var mxDragVal = attrs.mxDraggable;
							if (mxDragVal.toLowerCase() !== 'false') {
								element.attr('draggable', true).on('dragstart', dragstartHandler);
							} else {
								element.removeAttr('draggable').off('dragstart', dragstartHandler);
							}
						};
						handleDragging();
						attrs.$observe('mxDraggable', handleDragging);
					},
				};
			},
		])

		/**
		 * @ngdoc directive
		 * @name mx.components:mxDroppable
		 * @module mx.components
		 * @restrict A
		 *
		 * @description
		 * Enables possibility to drop on this element another draggable element.
		 *
		 * `mxDroppable` gets string.
		 *    If it's `false` then dropping will be disallowed.
		 *    If it's some method then it will be executed.
		 *
		 * Example 1:
		 * ```html
		 *    <div mx-draggable='{"mydata": 123}'></div>
		 *    <div mx-droppable="vm.onDrop($event)"></div>
		 * ```
		 *
		 * Example 2:
		 * ```html
		 *    <div mx-draggable='{{ vm.draggable ? "{\"mydata\": 123}" : "false" }}'></div>
		 *    <div mx-droppable='{{ vm.draggable ? "vm.onDrop($event)" : "false" }}'></div>
		 * ```
		 *
		 **/
		.directive('mxDroppable', [
			'$parse',
			function mxDroppableDirective($parse) {
				return {
					restrict: 'A',
					link: function (scope, element, attrs) {
						var dropHandler = function (event) {
							var draggableAttr;
							event.preventDefault();
							event.stopPropagation();
							element.removeClass('mx-drag-hover');
							if (event && event.target) {
								draggableAttr = $(event.target).closest('[mx-droppable]').attr('mx-droppable');
								if (draggableAttr) {
									$parse(draggableAttr || '')(scope, { $event: event });
								}
							}
						};
						var dragoverHandler = function (event) {
							event.preventDefault();
							event.stopPropagation();
							element.addClass('mx-drag-hover');
						};
						var dragleaveHandler = function (event) {
							event.preventDefault();
							event.stopPropagation();
							element.removeClass('mx-drag-hover');
						};
						var handleDropping = function () {
							var mxDropVal = attrs.mxDroppable;
							if (mxDropVal && mxDropVal.toLowerCase() !== 'false') {
								element.attr('allow-drop', true).on('drop', dropHandler).on('dragover', dragoverHandler).on('dragleave', dragleaveHandler);
							} else {
								element.removeAttr('allow-drop').off('drop', dropHandler).off('dragover', dragoverHandler).off('dragleave', dragleaveHandler);
							}
						};
						//handleDropping();
						attrs.$observe('mxDroppable', handleDropping);
					},
				};
			},
		])

		/**
		 * @ngdoc service
		 * @name mx.components.DragNDropUtils
		 * @module mx.components
		 *
		 * @description
		 * Allows to pass data from draggable to droppable element.
		 * It has 2 methods: `getDropData()` and `setDropData()`
		 *
		 **/
		.factory('mx.components.DragNDropUtils', [
			'mx.internationalization',
			function dragNDropUtils(internationalization) {
				return {
					getDropData: getDropData,
					setDropData: setDropData,
				};

				function getDropData(event) {
					var dataTransfer = event.dataTransfer || (event.originalEvent && event.originalEvent.dataTransfer);
					if (dataTransfer) {
						return JSON.parse(dataTransfer.getData('text'));
					} else {
						throw new Error(internationalization.get('components.errors.can_no_access_data_transfer_object'));
					}
				}

				function setDropData(event, value) {
					var dataTransfer = event.dataTransfer || (event.originalEvent && event.originalEvent.dataTransfer);
					if (dataTransfer) {
						dataTransfer.setData('text', JSON.stringify(value));
					} else {
						throw new Error(internationalization.get('components.errors.can_no_access_data_transfer_object'));
					}
				}
			},
		]);
})();
